'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nitroHeading = require('../nitro-heading');

var _nitroHeading2 = _interopRequireDefault(_nitroHeading);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NitroNavBar = function NitroNavBar(props) {
  var label = props.label,
      actionOnHeading = props.actionOnHeading,
      action = props.action,
      header = props.header,
      arrowVariant = props.arrowVariant,
      headerVariant = props.headerVariant,
      headerSize = props.headerSize,
      arrowOpacity = props.arrowOpacity,
      arrowSize = props.arrowSize,
      drillDownEllipsis = props.drillDownEllipsis;


  if (header) {
    return _react2.default.createElement(
      _styles.Navbar,
      props,
      _react2.default.createElement(
        _styles.NavbarIcon,
        { header: true, onClick: action, opacity: arrowOpacity },
        _react2.default.createElement(_nitroIcon2.default, {
          name: 'arrow-back',
          size: 12,
          clickable: true,
          variant: arrowVariant
        })
      ),
      _react2.default.createElement(
        _styles.DrillDownTitle,
        { drillDownEllipsis: drillDownEllipsis },
        _react2.default.createElement(_nitroHeading2.default, {
          header: true,
          label: label,
          size: headerSize,
          noMargin: true,
          inline: true,
          variant: headerVariant,
          onClick: actionOnHeading ? action : null
        })
      )
    );
  }

  return _react2.default.createElement(
    _styles.Navbar,
    props,
    _react2.default.createElement(
      _styles.NavbarIcon,
      { onClick: action },
      _react2.default.createElement(_nitroIcon2.default, { name: 'arrow-back', size: arrowSize, variant: arrowVariant })
    ),
    _react2.default.createElement(
      _styles.DrillDownTitle,
      { drillDownEllipsis: drillDownEllipsis },
      _react2.default.createElement(_nitroHeading2.default, {
        label: label,
        size: headerSize,
        variant: headerVariant,
        noMargin: true,
        inline: true,
        onClick: actionOnHeading ? action : null
      })
    )
  );
};

NitroNavBar.defaultProps = {
  headerOpacity: 1,
  arrowSize: 12
};

NitroNavBar.propTypes = {
  action: _propTypes2.default.func,
  actionOnHeading: _propTypes2.default.bool,
  url: _propTypes2.default.string,
  label: _propTypes2.default.string.isRequired,
  header: _propTypes2.default.bool,
  arrowVariant: _propTypes2.default.string,
  headerVariant: _propTypes2.default.string,
  arrowOpacity: _propTypes2.default.string,
  headerSize: _propTypes2.default.string,
  headerOpacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  arrowSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  className: _propTypes2.default.string,
  drillDownEllipsis: _propTypes2.default.bool
};

exports.default = NitroNavBar;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-nav-bar/NitroNavBar.js
// module id = 3020
// module chunks = 4